import { useRetailerCore } from "@faire/retailer-visitor-shared/hooks/retailer/RetailerCoreProvider";
import {
  useSettingMigrateRetailerStore,
  useSettingMigrateUseRetailerOnly,
} from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";

const useRetailerControl = () => {
  const {
    retailer,
    retailerToken,
    refetchRetailer,
    retailerName,
    retailerPromise,
    setRetailer,
  } = useRetailerStore([
    "retailer",
    "retailerToken",
    "refetchRetailer",
    "retailerName",
    "retailerPromise",
    "setRetailer",
  ]);

  return {
    retailer,
    retailerToken,
    refetchRetailer,
    retailerName,
    retailerPromise,
    setRetailer,
  };
};

export const useRetailer = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  const shouldUseRetailerOnly = useSettingMigrateUseRetailerOnly();
  if (shouldUseHooksMigration || shouldUseRetailerOnly) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useRetailerCore();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useRetailerControl();
};
